module.exports = __webpack_public_path__ + "img/placeholder.ccf271c2.jpg";